<template>
  <div class="test-container p-20">
    <div class="div">Test</div>
    <router-link to="/">
      <div style="display:inline-block;background:#eee;width:200px;height:100px;">Home</div>
    </router-link>
    <router-link to="/hold">
      <p>
        <el-button style="margin:10px;">设置页面访问权限</el-button>
      </p>
    </router-link>
    <router-link to="/test">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test1">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test2">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <v-test></v-test>
    <el-button style="margin:10px;" @click="getData">点击获取数据</el-button>
    <p></p>
    <ul>
      <li style="border-bottom:1px solid #ccc;line-height:20px;" :key="index"
        v-for="(item,index) in news">{{item.title}}</li>
    </ul>
    <p></p>
    <el-input style="margin:10px; width:200px;" v-model="txt" placeholder="请输入评论内容" />
    <p></p>
    <el-button style="margin:10px;" @click="_comment">验证登录功能，点击评论</el-button>
    <ul>
      <li style="border-bottom:1px solid #ccc;line-height:20px;" v-for="(item,index) in list"
        :key="index">{{item.content}}</li>
    </ul>
    <p></p>
    <el-button style="margin:10px;" @click="quit">退出</el-button>
  </div>
</template>

<script type="text/ecmascript-6">
//  import {getAllNews, addComment, getCommentByAid} from '../../common/js/api.js';
//  import {tool} from '../../common/js/util.js';
//  import TestComponent from '../../components/test/test.vue';
//  import ElButton from "../../../node_modules/element-ui/packages/button/src/button";
//  import ElInput from "../../../node_modules/element-ui/packages/input/src/input";
export default {
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      list: [],
      news: [],
      isListPage: "",
      navIndex: 0,
      txt: ""
    };
  },

  computed: {},

  created() {
    //      console.log('created');
    //      this._getCommentByAid();
  },

  methods: {
    _getCommentByAid() {
      getCommentByAid(200).then(res => {
        console.log(res.data);
        this.list = res.data;
      });
    },
    getData() {
      getAllNews(1, 10).then(res => {
        console.log(res);
        this.news = res.data.data;
      });
    },
    _comment() {
      addComment({
        content: this.txt,
        news_id: 200,
        parents_id: 0,
        reply_member_id: "123456789"
      }).then(res => {
        console.log(res);
        this._getCommentByAid();
      });
    },
    quit() {
      tool.setCookie("token", "");
    }
  },

  components: {
    ElInput,
    ElButton,
    "v-test": TestComponent
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import url("../../common/less/variable.less");

.test-container {
  width: 100%;
  height: 100%;
  background: white;
}
</style>
